<!--
   抽屉

   @date:2022/09/07
   @author 金星晖<xinghui0928@163.com, www.xinghuijin.com>
   @copyright 南京云柜<yun-gui.com>
-->
<style lang="less">
.__g-modal-primary {
  .position(fixed;0;0;0;0);
  overflow: auto;
  //display: flex;
  //align-items: flex-start;
  //justify-content: center;
  // 所有dialog都要1000
  z-index: @modalIndex;
  font-size: 14px;
  line-height: 14px;
  background-color: @modalBackground;
  padding: 0;
  .__g-modal-con {
    position: relative;
    //position: absolute;
    max-height: 100%;
    padding: @containerGap 0 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border: 1px solid @lineColorNormal;
    box-shadow:0 0 12px 4px rgba(0,47,154,0.2);
    border-radius:6px;
    color: @textColorNormal;
    //transition: all @transitionTime25;
    //background-color: white;
    &.__g-modal-back-type-1 {background-color: @backColorStrong;}
    &.__g-modal-back-type-2 {background-color: @backColorNormal}
    .__g-modal-header {
      padding: 4px 15px @containerGap;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: @textColorStrong;
      cursor: move;
      &:nth-child(1) {
        font-size: 18px;
        line-height: 16px;
        font-weight: bold;
      }
      // 只有标题栏空白处和纯文本标题可拖动，光标要跟实际行为一致
      // （slot="title" 里放的是 tab 等交互元素，不能显示成可拖动）
      p {
        cursor: default;
        &.__g-modal-title-text {
          cursor: move;
        }
      }
      .ivu-icon {
        cursor: pointer;
        font-size: 28px;
      }
    }
    .__g-modal-content {
      padding: 0 15px;
      flex: 1;
      overflow: auto;
    }
    .__g-modal-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: @containerGap;
      background-color: @backColorLight;
    }
  }
}
</style>

<template>
  <div
    role="alert"
    class="__g-modal-primary"
  >
    <transition
      name="top-in"
      @after-leave="handleAfterLeave"
    >
      <div
        v-show="visible"
        ref="modalRef"
        :style="containerWidth"
        class="__g-modal-con"
        :class="'__g-modal-back-type-' + backType"
      >
        <!--标题-->
        <div
          class="__g-modal-header"
          @mousedown="onMouseDown"
          @mouseup="onMouseup"
        >
          <p
            v-if="title"
            class="__g-modal-title-text"
          >
            {{ title }}
          </p>
          <p v-else>
            <slot name="title" />
          </p>
          <span
            v-if="closeable"
            @mousedown.stop
            @click.stop="_close"
          >
            <Icon type="md-close" />
          </span>
        </div>
        <!--内容-->
        <div class="__g-modal-content">
          <slot name="content" />
        </div>
        <!--底部按钮-->
        <div
          v-if="showBottom"
          class="__g-modal-footer"
        >
          <div>
            <slot name="button" />
          </div>
          <yg-button
            v-if="sureText"
            type="primary"
            :disabled="sureButtonDisabled"
            :disabled-text="sureButtonDisabledText"
            @click="_sure"
          >
            {{ sureText }}
          </yg-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { onHandler, offHandler } from '@/libs/utils.js';
export default {
  name: 'YgModal',
  components: {},
  props: {
    width: {
      type: [Number, String],
      // box-sizing:border-box
      default: 300
    },
    title: {
      type: String,
      default: ''
    },
    sureText: {
      type: String,
      default: '确认'
    },
    sureButtonDisabled: {
      type: Boolean,
      default: false
    },
    sureButtonDisabledText: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: true
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    backType: {
      type: Number,
      // 1: 蓝色背景，2：白色背景
      default: 1
    }
  },
  data () {
    return {
      visible: false,
      isDragging: false,
      currentDragStyle: ''
    };
  },
  computed: {
    containerWidth () {
      // if (this.$store.state.app.smallScreen) {
      //   return 'width: 100%';
      // }
      const temp = this.width + '';
      if (temp.includes('%') || temp.includes('px')) {
        return 'width:' + this.width;
      }
      return 'width:' + this.width + 'px; ' + this.currentDragStyle;
    }
  },
  created () {
    onHandler(window, 'keydown', this.addKeyboardObserver);
    const cc = this.$storage.autoConfig;
    const lastShow = cc.lastShowEscTip;
    const t = (new Date()).getTime() - lastShow;
    if (t > 604800000) {
      cc.lastShowEscTip = (new Date()).getTime();
      this.$storage.autoConfig = cc;
      // 一周弹一次
      this.$Notice.info({
        title: '操作提示',
        desc: '按ESC可关闭弹层，本条提示近一周内不会展示。请手动关闭此提示!',
        duration: 0
      });
    }
  },
  mounted () {
    this.visible = true;
    document.body.style.overflow = 'hidden';
    this.$nextTick(() => {
      const targetRect = this.$refs.modalRef.getBoundingClientRect();
      const targetWidth = targetRect.width;
      const moveX = window.innerWidth * 0.5 - targetWidth * 0.5;
      const moveY = 60;
      this.currentDragStyle = ` left:${moveX}px;top:${moveY}px;user-select: none;`;
      // this.currentDragStyle = ` transform:translate(${moveX}px, ${moveY}px);user-select: none;`;
    });
  },
  beforeDestroy () {
    document.body.style.overflow = 'auto';
    offHandler(window, 'keydown', this.addKeyboardObserver);
  },
  methods: {
    addKeyboardObserver (e) {
      if (e.keyCode === 27) { // 27是esc
        if (this.$store.state.user.globalSetting.escClose === '2') return this._close();
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p style="font-size: 16px;">是否确定关闭弹层？</p><p style="color: #a0a0a0;font-size: 12px">*注:可在全局设置中关闭询问</p>',
          onOk: () => {
            this._close();
          }
        });
      }
    },
    onMouseDown (e) {
      // 只响应鼠标左键
      if (e.button !== 0) return;
      // 只有按在标题栏空白处或纯文本标题上时才允许拖动。
      // 标题栏里还塞着关闭按钮、以及 slot="title" 的 tab 等交互元素：
      // 它们只做 @click.stop 是挡不住拖动的 —— 一旦按下就注册了 document 的 mousemove，
      // 指针轻微移动就会把弹窗瞬移到光标处，元素从光标下移走，click 便永远不触发，
      // 表现为"点关闭按钮反而把弹窗拖走了/点了没反应"。
      if (e.target !== e.currentTarget && !e.target.classList.contains('__g-modal-title-text')) {
        return;
      }
      this.isDragging = true;
      const targetRect = this.$refs.modalRef.getBoundingClientRect();
      const targetWidth = targetRect.width;
      const targetHeight = targetRect.height;
      const safeRange = 0;
      const safeW = window.innerWidth - targetWidth;
      const safeH = window.innerHeight - targetHeight;
      const onMouseMove = (e2) => {
        let moveX = e2.x - targetWidth * 0.5;
        let moveY = e2.y - 30;
        if (moveX > safeW) {
          moveX = safeW;
        }
        if (moveX < safeRange) {
          moveX = safeRange;
        }
        if (moveY > safeH) {
          moveY = safeH;
        }
        if (moveY < safeRange) {
          moveY = safeRange;
        }
        // transform会改变上下文，会导致子元素的position:fixed失效，不会定位到整个浏览器窗口
        // this.currentDragStyle = ` transform:translate(${moveX}px, ${moveY}px);user-select: none;`;
        this.currentDragStyle = ` left:${moveX}px;top:${moveY}px;user-select: none;`;
      };
      const onMouseup = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseup);
        this.currentDragStyle = this.currentDragStyle.replace('user-select: none;', '');
      };
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseup);
    },
    onMouseup () {
      this.isDragging = false;
    },
    handleAfterLeave () {
      this.$emit('on-close');
    },
    _sure () {
      this.$emit('on-sure');
    },
    _close () {
      this.visible = false;
    }
  }
};
</script>
